export enum FundAllocationSteps {
    CONFIRM_ACTION = 0,
    ALLOCATION_STEP_1 = 1,
    ALLOCATION_STEP_2 = 2,
    CONFIRM_ALLOCATION = 3,
    SUCCESS = 4
}

export enum Actions {
  ADD = "add",
  REALLOCATE = "reallocate",
  MOVE_FUNDS = "move funds",
  ALLOCATE = "allocate funds"
}

export enum FundAllocationButtons {
  CANCEL = "cancel",
  ADD_FUNDS = "add funds",
  SPLIT_FUNDS = "split funds",
  ADD_TO_TOTAL_FUNDS = "Add to total fund",
  CONFIRM = "confirm",
  NEXT = "next",
  BACK_TO_FUND_ALLOCATION = "Back to fund allocation"
}